export default __webpack_public_path__ + "static/media/ic-timer.c9d9c580.svg";